import script from "./ServiceOutageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceOutageModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceOutageModal.vue?vue&type=style&index=0&id=66b8f1b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b8f1b3"]])

export default __exports__